// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getNotifyStyle } from "@ces/App/Components/Notify";
import dataTableStyles from "@ces/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { recentWishListsStyles } from "@ces/Overrides/Widgets/Common/RecentWishLists";
import LinkArrowRight from "@ces/XDL/Icons/LinkArrowRight";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { color, mergeWithCss, xScreen } from "@ces/XDL/Utilities";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

recentWishListsStyles.wishListCardGridItem = {
    width: 12,
    css: css`
        padding: 0;
    `,
};

recentWishListsStyles.wishListCard = {
    container: {
        css: css`
            display: grid;
            grid-template-columns: minmax(0, 319px) minmax(0, 430px) minmax(110px, 1fr);
            ${xScreen("lte", "md")} {
                grid-template-columns: 1fr;
            }
        `,
    },
    imagesWrapper: {
        css: css`
            ${xScreen("lte", "md")} {
                grid-column: 1 / 2;
                grid-row: 2 / 3;
                column-gap: 20px;
            }
        `,
    },
    actionsWrapper: {
        css: css`
            ${xScreen("lte", "md")} {
                grid-column: 1 / 2;
                grid-row: 3 / 4;
            }
        `,
    },
    sharingStatus: {
        privateTooltip: {
            cssOverrides: {
                tooltipClickable: css`
                    &&& {
                        margin-left: 0;
                    }
                `,
            },
        },
    },
};

recentWishListsStyles.noWishListsText = {
    ...mergeWithCss(getNotifyStyle("info", true), {
        css: css`
            margin: 0;
        `,
    }),
};

recentWishListsStyles.dividerGridItem = {
    width: 12,
    css: css`
        border-top: 1px solid ${color("common.border")};
        padding: 0;
        &&& {
            margin-top: 16px;
            margin-bottom: 16px;
        }
    `,
};

recentWishListsStyles.cardListStyles = {
    gridContainer: {
        gap: 40,
        offsetCss: css`
            &&& {
                width: 100%;
                margin: 0;
            }
        `,
        css: css`
            &&& {
                padding-right: 0;
                padding-left: 0;
            }
        `,
    },
};

recentWishListsStyles.cardContainer = {
    cardDivider: {
        css: css`
            width: 100%;
            margin: 0;
            border-bottom: none;
            &:nth-child(2) > ${GridItemStyle} {
                padding-top: 0;
            }
        `,
    },
    gridItem: {
        width: 12,
        css: css`
            padding: 0px;
        `,
    },
};

recentWishListsStyles.noWishListsGridItem = {
    width: 12,
    css: css`
        &&& {
            margin-top: 16px;
            text-align: center;
            padding: 0;
        }
    `,
};

recentWishListsStyles.titleTypographyStyles = {
    wrapper: {
        css: css`
            justify-content: space-between;
            align-items: flex-end;
            flex-wrap: wrap;
            margin-bottom: 0px;

            ${xScreen("lte", "md")} {
                flex-direction: row;
                align-items: baseline;
            }

            ${xScreen("lt", "sm")} {
                flex-direction: column;
            }
        `,
    },
    title: {
        variant: "h3",
        color: "text.main",
    },
    linkWithArrow: {
        typographyProps: {
            size: 12,
            weight: fontConfig.weight.bold,
            css: css`
                letter-spacing: 0;
                line-height: 15px;
            `,
        },
        icon: {
            iconProps: {
                src: LinkArrowRight,
                color: "text.link",
                css: css`
                    height: 13px;
                    width: 11px;
                `,
            },
            position: "right",
        },
    },
    link: {
        typographyProps: {
            size: 12,
            css: css`
                line-height: 15px;
            `,
        },
    },
};
